import { render, staticRenderFns } from "./style.vue?vue&type=template&id=53da0852&scoped=true"
import script from "./style.vue?vue&type=script&lang=js"
export * from "./style.vue?vue&type=script&lang=js"
import style0 from "./style.vue?vue&type=style&index=0&id=53da0852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da0852",
  null
  
)

export default component.exports